import { ovatBill, openedInvoice, vehicleInvoice } from 'redevConfig'

const list = (ovatBill && ovatBill.list) || ''
const detailList = (ovatBill && ovatBill.detailList) || ''
const checkBillDetail = (ovatBill && ovatBill.checkBillDetail) || ''
const dataCollection = (ovatBill && ovatBill.dataCollection) || ''
const relatedInvoiceDetail = (openedInvoice && openedInvoice.detail) || ''
const relatedVehicleDetail = (vehicleInvoice && vehicleInvoice.add) || ''
const relatedRollDetail = (openedInvoice && openedInvoice.rollDetail) || ''
const billPreview = (ovatBill && ovatBill.billPreview) || ''

const ovatBillListCtrlPage = list ? require(`redevelopment/outputManage/ovatBill/${list.templateName}`) : require('./view/ovatBillListCtrl.html')
const billDetailListCtrlPage = detailList ? require(`redevelopment/outputManage/ovatBill/${detailList.templateName}`) : require('./view/billDetailListCtrl.html')
const checkBillDetailCtrl = checkBillDetail ? require(`redevelopment/outputManage/ovatBill/${checkBillDetail.templateName}`) : require('./view/checkBillDetailCtrl.html')
const dataCollectionPage = dataCollection ? require(`redevelopment/outputManage/ovatBill/${dataCollection.templateName}`) : require('./view/dataCollection.html')
const relatedInvoiceDetailPage = relatedInvoiceDetail ? require(`redevelopment/outputManage/openedInvoice/${relatedInvoiceDetail.templateName}`) : require('app/outputManage/billManage/openedInvoice/view/openedInvoiceDetail.html')
const relatedVehicleDetailPage = relatedVehicleDetail ? require(`redevelopment/outputManage/vehicleInvoice/${relatedVehicleDetail.templateName}`) : require('app/outputManage/fillOpenManage/vehicleInvoice/view/add.html')
const relatedRollDetailPage = relatedRollDetail ? require(`redevelopment/outputManage/openedInvoice/${relatedRollDetail.templateName}`) : require('app/outputManage/billManage/openedInvoice/view/rollTypeInvoice.html')
const billPreviewCtrlPage = billPreview ? require(`redevelopment/outputManage/ovatBill/${billPreview.templateName}`) : require('./view/billPreviewCtrl.html')

// 框架模板路由
export const ovatBillRouter = {
    state: 'outputManage.FOManage.ovatBill',
    config: {
        abstract: true,
        url: '/ovatBill',
        template: '<div ui-view></div>',
        // controller: 'ovatBillCtrl',
        title: '销售单处理',
        default: 'outputManage.FOManage.ovatBill.list',
    },
}

export const ovatBillListCtrlRouter = {
    state: 'outputManage.FOManage.ovatBill.list',
    config: {
        url: '/list',
        template: ovatBillListCtrlPage,
        controller: 'ovatBillListCtrl',
    },
}
export const billDetailListCtrlRouter = {
    state: 'outputManage.FOManage.ovatBill.detailList',
    config: {
        url: '/detailList/:billId',
        template: billDetailListCtrlPage,
        controller: 'billDetailListCtrl',
        title: '编辑销售单',
    },
}

export const spiltBillDetailListCtrlRouter = {
    state: 'outputManage.FOManage.ovatBill.spiltdetailList',
    config: {
        url: '/spiltdetailList/:billId',
        template: billDetailListCtrlPage,
        controller: 'billDetailListCtrl',
        title: '拆分销售单',
    },
}

export const checkBillDetailCtrlRouter = {
    state: 'outputManage.FOManage.ovatBill.checkBillDetail',
    config: {
        url: '/checkBillDetail/:obj',
        template: checkBillDetailCtrl,
        controller: 'checkBillDetailCtrl',
        title: '销售单明细',
    },
}
export const billPreviewCtrlRouter = {
    state: 'outputManage.FOManage.billPreview',
    config: {
        url: '/billPreview',
        template: billPreviewCtrlPage,
        controller: 'billPreviewCtrl',
        title: '开票预览',
    },
}
export const dataCollectionRouter = {
    state: 'outputManage.FOManage.ovatBill.dataCollection',
    config: {
        url: '/dataCollection',
        template: dataCollectionPage,
        controller: 'dataCollectionCtrl',
        title: '客户端采集',
    },
}
export const relatedInvoiceDetailRouter = {
    state: 'outputManage.FOManage.ovatBill.relatedInvoiceDetail',
    config: {
        url: '/relatedInvoiceDetail/:invoiceId',
        template: relatedInvoiceDetailPage,
        controller: 'openedInvoiceDetailCtrl',
        title: '关联发票详情',
    },
}
export const relatedVehicleDetailRouter = {
    state: 'outputManage.FOManage.ovatBill.relatedVehicleDetail',
    config: {
        url: '/relatedVehicleDetail/:invoiceId',
        template: relatedVehicleDetailPage,
        controller: 'vehicleDetailCtrl',
        title: '关联发票详情',
    },
}
export const relatedRollDetailRouter = {
    state: 'outputManage.FOManage.ovatBill.relatedRollDetail',
    config: {
        url: '/relatedRollDetail/:invoiceId',
        template: relatedRollDetailPage,
        controller: 'rollDetailCtrl',
        title: '关联发票详情',
    },
}



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/ovatBill/Routers.js